module.exports = __webpack_public_path__ + "img/img_thumb_0302.ada3ae52.png";